// Package Imports
import { useState } from 'react'
import { Outlet } from '@tanstack/react-router'

// Core Imports
import { useTheme } from '@/core/hooks/use-theme'

// Module Imports
import Sidebar from '@/modules/dashboard/components/sidebar'
import Header from '@/modules/dashboard/components/header'

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false)
  const { theme } = useTheme()
  const isCanli = theme === 'canli'

  const shellClass = isCanli
    ? 'flex h-screen overflow-hidden bg-[var(--app-bg)] text-[var(--app-text)]'
    : 'flex h-screen overflow-hidden bg-gray-100'

  return (
    <div className={shellClass}>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="relative flex flex-1 flex-col overflow-hidden">
        <Header setSidebarOpen={setSidebarOpen} />
        <main className="mt-16 flex-1 overflow-auto p-4 lg:ml-64 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default DashboardLayout
